export const endpoints = {
  map: "/map-search-results/",
  users: {
    me: "/users/me/",
    register: "/users/register/",
    login: "/users/login/",
    twoFactor: {
      status: "/users/2fa/",
      login: "/users/login/2fa/",
      setup: "/users/2fa/setup/",
      confirmSetup: "/users/2fa/setup/confirm/",
      disable: "/users/2fa/disable/",
      regenerateBackupCodes: "/users/2fa/backup-codes/regenerate/"
    },
    logout: "/users/logout/",
    changePassword: "/users/password/change/",
    reset: "/users/password/reset/",
    confirmReset: "/users/password/reset/confirm/",
    language: "/users/language/"
  },
  samlTokenRetrieve: "/saml/token/retrieve/",
  businessAddresses: "/business-addresses/",
  categories: "/companies/categories/",
  websites: "/websites/",
  wizard: {
    company: {
      categories: "/keywords/categories/",
      profile: "/companies/"
    },
    businessAddresses: {
      autocomplete: "/map-places/"
    },
    gus: "/gus/"
  },
  keywords: {
    company: "/keywords/",
    companyDelete: keywordId => `/keywords/${keywordId}/`
  },
  competition: {
    default: "/companies/",
    companyCompetition: "/company-competition/",
    mapCompetitionList: "/map-search-competition/",
    limitManagement: "competitors-limits-management/"
  },
  locations: {
    suggested: "/keywords/suggested-locations/",
    rejected: "/keywords/rejected-locations/"
  },
  limits: {
    facilities: "/facilities-limits-management/",
    deleteFacility: id => `/facilities-limits-management/${id}/`,
    members: "/members-limits-management/",
    deleteMember: id => `/members-limits-management/${id}/`,
    keywords: "/keywords-limits-management/",
    deleteKeyword: id => `/keywords-limits-management/${id}/`,
    tags: "/tags-limits-management/",
    deleteTag: id => `/tags-limits-management/${id}/`,
    competitors: "/competitors-limits-management/",
    deleteCompetitor: id => `/competitors-limits-management/${id}/`
  },
  periodicRankings: "/periodic-rankings/",
  periodicRankingsTable: "/periodic-rankings-table/",
  periodicRankingsTableExport: "/periodic-rankings-table/export/",
  reportExportStatus: exportId => `/report-export/${exportId}/`,
  reportExportDownload: exportId => `/report-export/${exportId}/download/`,
  periodicRankingsTableSummary: "/periodic-rankings-table/summary/",
  compareReviews: "/compare/reviews/",
  comparePosts: "/compare/posts/",
  searchLocations: "/search-locations/",
  scores: "/scores/",
  competitionScores: "/competition-scores/",
  avgGMBRatings: "/avg-google-my-business-ratings/",
  avgMapSearchResult: "/avg-map-search-results/",
  subscriptionVouchers: "/subscription-vouchers/",
  facilities: "/facilities/",
  facilitiesCities: "/facilities-cities/",
  facilitiesGroups: "/facilities-groups/",
  facilitiesLabels: "/facilities-labels/",
  facilitiesUpdateStatuses: "/facilities-update-statuses/",
  facilitiesBulkEdit: "/facilities-bulk-edit/",
  facilitiesExport: "/facilities-export/",
  facilitiesImport: "/facilities-import/",
  facilitiesLimitsManagement: "/facilities-limits-management/",
  osmSettings: "/osm-settings/",
  googleOAuth: "/google-oauth-accounts/",
  gmbProfilePlaces: "/gmb-profiles/",
  gmbSearch: "/gmb-search/",
  gmbLocationCreate: "/gmb-location-create/",
  gmbLocationImports: "/gmb-location-imports/",
  companySubscriptions: "/company-subscriptions/",
  subscriptionBillingPreview: "/company-subscriptions/billing-preview/",
  gmbInsights: "/gmb-insights-v2/",
  gmbInsightsExport: "/gmb-insights-v2/export/",
  gmbInsightsOld: "/gmb-insights/",
  gmbPost: postId => `/gmb-local-posts/${postId}/`,
  gmbPostCancel: postId => `/gmb-local-posts/${postId}/cancel/`,
  gmbPosts: "/gmb-local-posts/",
  gmbPostsSchedule: "/gmb-local-posts-schedule/",
  gmbPostsScheduleCalendar: "/gmb-local-posts-schedule/calendar/",
  gmbPostScheduled: postId => `/gmb-local-posts-schedule/${postId}/`,
  gmbPostsInsights: "/gmb-local-posts-insights/",
  gmbPostsFacilities: postId => `/gmb-local-posts/${postId}/facilities/`,
  gmbMediaFacilities: mediaId => `/gmb-media/${mediaId}/facilities/`,
  gmbPostsStoreLocator: postId => `/gmb-local-posts/${postId}/store-locator/`,
  gmbMedia: "/gmb-media/",
  gmbMediaId: id => `/gmb-media/${id}/`,
  gmbMediaStoreLocator: id => `/gmb-media/${id}/store-locator/`,
  gmbMediaStorage: "/gmb-media-storage/",
  gmbMediaTypes: "/gmb-media-types/",
  reviews: "/gmb-reviews/",
  reviewsSearch: "/gmb-reviews-search/",
  gmbCustomerMedia: "/gmb-customer-media/",
  gmbCustomerMediaByReviews: "/gmb-customer-media/by-reviews/",
  gmbCustomerMediaSummary: "/gmb-customer-media/summary/",
  gmbCustomerMediaExport: "/gmb-customer-media/export/",
  gmbCustomerMediaAssessment: id => `/gmb-customer-media/${id}/assessment/`,
  gmbCustomerMediaNote: id => `/gmb-customer-media/${id}/note/`,
  gmbCustomerMediaReport: id => `/gmb-customer-media/${id}/report/`,
  gmbCustomerMediaAiAccuracy: id => `/gmb-customer-media/${id}/ai-accuracy/`,
  companyContext: "/company-context/",
  companyContextApprove: "/company-context/approve/",
  mediaVerificationRules: "/media-verification-rules/",
  phrasesGroups: "/phrases-groups/",
  phrasesGroupDetails: id => `/phrases-groups/${id}/`,
  phrases: "/phrases/",
  phrase: id => `/phrases/${id}/`,
  reviewsBulkTag: "/gmb-reviews/bulk-tag/",
  reviewsExport: "/gmb-reviews/export/",
  reviewById: id => `/gmb-reviews/${id}/`,
  reviewVisibility: id => `/gmb-reviews/${id}/hide/`,
  reviewsReply: postId => `/gmb-reviews/${postId}/reply/`,
  reviewsBulkReply: "/gmb-reviews-bulk-reply/",
  reviewsTemplateBulkReply: "/gmb-reviews-template-bulk-reply/",
  reviewsStats: "/gmb-reviews-stats/",
  reviewsStatsTable: "/gmb-reviews-stats-table/",
  generateReviewReply: (companyId, gmbReviewId, userId) =>
    `review-reply/generate-review-reply/${companyId}/${gmbReviewId}/${userId}/`,
  aiReplyLimit: `/ai-review-reply-limit/`,
  aiReviewReplyConfig: "/ai-review-reply-config/",
  reviewsReplyCategories: "/review-reply-categories/",
  reviewsReplyCategory: categoryId => `/review-reply-categories/${categoryId}/`,
  reviewsReplyTemplates: "/review-reply-templates/",
  reviewsReplyTemplate: templateId => `/review-reply-templates/${templateId}/`,
  reviewsTags: reviewId => `/gmb-reviews/${reviewId}/tags/`,
  reviewTagCategory: (reviewId, categoryId) =>
    `/gmb-reviews/${reviewId}/tags/${categoryId}/`,

  reviewsNote: reviewId => `/gmb-reviews/${reviewId}/notes/`,
  gmbAttributes: "/gmb-attributes/",
  gmbMoreHours: "/gmb-more-hours/",
  gmbExternalChanges: "/gmb-external-changes/",
  gmbExternalChange: changeId => `/gmb-external-changes/${changeId}/`,
  gmbExternalChangesGroupAction: "/gmb-external-changes-bulk-edit/",
  gmbExternalChangesSettings: "/gmb-external-changes-settings/",
  gmbExternalChangesProtectionSummary:
    "/gmb-external-changes/protection-summary/",
  gmbExternalChangesReject: "/gmb-external-changes/reject/",
  gmbServicesList: "/gmb-service-types/",
  gmbServicesListFreeForm: "/gmb-service-types/free-form/",
  updateGmbExternalChangesSettings: id =>
    `/gmb-external-changes-settings/${id}/`,
  dashboardReviewsStats: "/dashboard-reviews-stats/",
  dashboardInsights: "/dashboard-insights-v2/",
  dashboardInsightsOld: "/dashboard-insights/",
  dashboardGmbAddressesStats: "/dashboard-gmb-addresses-stats/",
  dashboardLocalPostsStats: "/dashboard-local-posts-stats/",
  companyMembers: companyId => `/companies/${companyId}/members/`,
  companyParent: companyId => `/companies/${companyId}/parent/`,
  companyDetails: companyId => `/companies/${companyId}/`,
  companyMembersLimitsManagement: "/members-limits-management/",
  enterpriseInvitation: "/invitations/enterprise/",
  acceptInvitation: "/invitations/accept/",
  resendInvitation: "/invitations/resend/",
  companyTags: "/tags/",
  companyTag: tagId => `/tags/${tagId}/`,
  mapsIntegration: "/maps-integration/",
  storeLocator: {
    config: "/store-locator/config/",
    defaultFaq: "/store-locator/faq/",
    defaultFaqById: id => `/store-locator/faq/${id}/`,
    facilityFaq: facilityId => `/store-locator/${facilityId}/faq/`,
    facilityFaqItem: (facilityId, itemId) =>
      `/store-locator/${facilityId}/faq/${itemId}/`,
    configCompany: companyId => `/store-locator/config/${companyId}/`,
    facilities: "/store-locator/config/facilities/",
    facilitiesGroups: "/store-locator/config/facilities-groups/",
    extraInfo: facilityId => `/store-locator/extra-info/${facilityId}/`,
    extraInfoSections: facilityId =>
      `/store-locator/extra-info/${facilityId}/sections/`,
    extraInfoSection: (facilityId, sectionId) =>
      `/store-locator/extra-info/${facilityId}/sections/${sectionId}/`
  },
  analytics: {
    gmb: {
      summary: "/analytics/summary/",
      heatmap: "/analytics/heatmap/",
      ratingsPinnedTable: "/analytics-table/ratings-pinned/",
      ratingsDetailsTable: "/reviews-analytics-details-table/ratings/",
      ratingsTable: "/analytics-table/ratings/",
      sentimentTable: "analytics-table/sentiment/",
      sentimentTableExport: "analytics-table/sentiment-export/",
      sentimentDetailsChart: "reviews-analytics-details/sentiment/",
      sentimentAggregatedTable: "analytics-table/sentiment-aggregated/",
      sentimentAggregatedTableExport:
        "analytics-table/sentiment-aggregated-export/",
      sentimentAggregatedDetailsChart:
        "reviews-analytics-details/sentiment-aggregated/",
      averageRatingsPinnedTable: "/analytics-table/average-pinned/",
      averageRatingsTable: "/analytics-table/average/",
      averageAnalyticsDetailsTable: "/reviews-analytics-details-table/average/",
      averageAnalyticsDetailsTableAll:
        "/reviews-analytics-details-table/average-without-category/",
      ratingsAnalyticsDetailsTable: "/reviews-analytics-details-table/ratings/",
      ratingsAnalyticsDetailsTableAll:
        "/reviews-analytics-details-table/ratings-without-category/",
      averageRatingsDetailsChart: "/reviews-analytics-details/average/",
      averageRatingsDetailsChartAll:
        "/reviews-analytics-details/average-without-category/",
      countDetailsChart: "/reviews-analytics-details/count/",
      countDetailsChartAll:
        "/reviews-analytics-details/count-without-category/",
      averageRatingsDetailsTablePinned:
        "/reviews-analytics-details-table/average-pinned/",
      ratingsAnalyticsDetailsTablePinned:
        "/reviews-analytics-details-table/ratings-pinned/",
      categorizationStatistics: "/categorization-statistics/",
      categorizationCompanySettings: "/categorization-company-settings/"
    },
    rb: {
      summary: "/review-booster/analytics/summary/",
      heatmap: "/review-booster/analytics/heatmap/",
      averageRatingsPinnedTable:
        "/review-booster/analytics-table/average-pinned/",
      averageRatingsTable: "/review-booster/analytics-table/average/",
      ratingsPinnedTable: "/review-booster/analytics-table/ratings-pinned/",
      ratingsTable: "/review-booster/analytics-table/ratings/",
      sentimentAggregatedTable:
        "/review-booster/analytics-table/sentiment-aggregated/",
      sentimentTable: "/review-booster/analytics-table/sentiment/"
    },
    mobileApps: {
      summary: "/mobile-analytics/summary/",
      heatmap: "/mobile-analytics/heatmap/",
      ratingsPinnedTable: "/mobile-analytics-table/ratings-pinned/",
      ratingsDetailsTable: "/mobile-reviews-analytics-details-table/ratings/",
      ratingsTable: "/mobile-analytics-table/ratings/",
      sentimentTable: "mobile-analytics-table/sentiment/",
      sentimentDetailsChart: "mobile-reviews-analytics-details/sentiment/",
      sentimentAggregatedTable: "mobile-analytics-table/sentiment-aggregated/",
      sentimentAggregatedDetailsChart:
        "mobile-reviews-analytics-details/sentiment-aggregated/",
      averageRatingsPinnedTable: "/mobile-analytics-table/average-pinned/",
      averageRatingsTable: "/mobile-analytics-table/average/",
      averageAnalyticsDetailsTable:
        "/mobile-reviews-analytics-details-table/average/",
      averageAnalyticsDetailsTableAll:
        "/mobile-reviews-analytics-details-table/average-without-category/",
      ratingsAnalyticsDetailsTable:
        "/mobile-reviews-analytics-details-table/ratings/",
      ratingsAnalyticsDetailsTableAll:
        "/mobile-reviews-analytics-details-table/ratings-without-category/",
      averageRatingsDetailsChart: "/mobile-reviews-analytics-details/average/",
      averageRatingsDetailsChartAll:
        "/mobile-reviews-analytics-details/average-without-category/",
      countDetailsChart: "/mobile-reviews-analytics-details/count/",
      countDetailsChartAll:
        "/mobile-reviews-analytics-details/count-without-category/",
      averageRatingsDetailsTablePinned:
        "/mobile-reviews-analytics-details-table/average-pinned/",
      ratingsAnalyticsDetailsTablePinned:
        "/mobile-reviews-analytics-details-table/ratings-pinned/",
      categorizationStatistics: "/categorization-statistics/",
      categorizationCompanySettings: "/categorization-company-settings/"
    }
  },
  mobileApps: {
    common: {
      reviews: "mobile-apps/reviews/",
      export: "mobile-apps/reviews/export/"
    },
    GOOGLE_PLAY: {
      reviews: "google-play/reviews/",
      reply: id => `google-play/reviews/${id}/reply/`,
      appsList: "google-play/apps/",
      tags: reviewId => `google-play/reviews/${reviewId}/categories/`,
      tag: (reviewId, tagId) =>
        `google-play/reviews/${reviewId}/categories/${tagId}/`,
      reviewsNote: reviewId => `/google-play/reviews/${reviewId}/notes/`,
      export: `/google-play/reviews/export/`,
      generateReviewReply: (companyId, reviewId, userId) =>
        `google-play/generate-google-play-review-reply/${companyId}/${reviewId}/${userId}/`
    },
    APP_STORE: {
      reviews: "app-store/reviews/",
      reply: id => `app-store/reviews/${id}/reply/`,
      appsList: "app-store/apps/",
      tags: reviewId => `app-store/reviews/${reviewId}/categories/`,
      tag: (reviewId, tagId) =>
        `app-store/reviews/${reviewId}/categories/${tagId}/`,
      reviewsNote: reviewId => `/app-store/reviews/${reviewId}/notes/`,
      export: `/app-store/reviews/export/`,
      generateReviewReply: (companyId, reviewId, userId) =>
        `app-store/generate-app-store-review-reply/${companyId}/${reviewId}/${userId}/`,
      deleteReply: id => `app-store/reviews/${id}/reply/`
    }
  },
  reviewBooster: {
    reviews: "review-booster/reviews/",
    settingsList: "review-booster/reviews/settings/",
    reviewBoosterSettings: "review-booster/review-booster-settings/",
    reviewBoosterLinksExport: key =>
      `review-booster/review-booster-settings/${key}/export-links/`,
    exportReviews: "review-booster/reviews/export/",
    reviewBoosterStatsExport: key =>
      `review-booster/review-booster-settings/${key}/export-statistics/`,
    reviewBoosterFunnelExport: key =>
      `review-booster/review-booster-settings/${key}/export-funnel-statistics/`,
    reviewBoosterReviewCategory: (reviewId, categoryId) =>
      `/review-booster/reviews/${reviewId}/categories/${categoryId}/`,
    reviewBoosterReviewCategories: reviewId =>
      `/review-booster/reviews/${reviewId}/categories/`,
    reviewBoosterAverageRating: key =>
      `/review-booster/review-booster-settings/${key}/average-rating/`,
    reviewBoosterStatistics: key =>
      `/review-booster/review-booster-settings/${key}/funnel-statistics/`,
    reviewBoosterTotalRating: key =>
      `/review-booster/review-booster-settings/${key}/total-rating/`,
    reviewBoosterCountRating: "/review-booster/statistics/count-rating/",
    reviewBoosterReviewsSummary: key =>
      `review-booster/review-booster-settings/${key}/reviews-summary/`
  },
  countries: "countries/",
  administrativeAreas: "administrative-areas/",
  timezones: "timezones/",
  facebook: {
    accounts: "facebook-accounts/",
    deleteAccount: id => `facebook-accounts/${id}/`,
    enablePages: "facebook-pages/enable/",
    deletePage: id => `facebook-pages/${id}/`,
    posts: "facebook-posts/",
    pages: "facebook-pages/"
  },
  googlePlay: {
    accounts: "google-play/oauth-accounts/",
    deleteAccount: id => `google-play/oauth-accounts/${id}/`,
    apps: "google-play/apps/",
    deleteApp: id => `google-play/apps/${id}/`
  },
  appStore: {
    accounts: "app-store/accounts/",
    deleteAccount: id => `app-store/accounts/${id}/`,
    apps: "app-store/apps/",
    deleteApp: id => `app-store/apps/${id}/`
  },
  payments: {
    root: "payments/",
    latestPayment: "payments/latest/",
    plans: "plans/",
    pricePreview: "price-preview/",
    afterPayment: "after-payment/",
    initialChosenPlan: "initial-chosen-plan/",
    promotionCodes: "promotion-codes/",
    campaigns: campaignId => `campaigns/${campaignId}/`
  },
  questionsAndAnswers: {
    questions: "q-and-a/questions/",
    question: questionId => `q-and-a/questions/${questionId}/`,
    createAnswerForQuestion: questionId =>
      `q-and-a/questions/${questionId}/create-answer/`,
    answers: "q-and-a/answers/",
    answer: answerId => `q-and-a/answers/${answerId}/`
  },
  autoReplies: {
    reviews: "review-auto-replies/",
    accept: "review-auto-replies/accept/",
    reject: "review-auto-replies/reject/"
  },
  invitationLink: "invitations/enterprise/free/",
  competitionComparison: {
    countries: "/competition-comparison/countries/",
    report: "/competition-comparison/reports/",
    competitorsTracked: "/competition-comparison/competitors/tracked/",
    competitorsTrackedById: id =>
      `/competition-comparison/competitors/tracked/${id}/`,
    sentimentProfiles: "/competition-comparison/sentiment/profiles/",
    sentimentTrends: "/competition-comparison/sentiment/trends/",
    competitorsAll: "/competition-comparison/competitors/all/",
    competitorsSuggestion: "/competition-comparison/competitors/suggestion/",
    statsAvgRating: "/competition-comparison/stats/avg-rating/",
    statsResponseRate: "/competition-comparison/stats/response-rate/",
    sentimentRadarChartProfilesData:
      "/competition-comparison/sentiment/radar-profiles/",
    filtersDateRange: "/competition-comparison/filters/date-range/"
  },
  appleMaps: {
    accounts: "apple-maps/accounts/",
    accountById: id => `apple-maps/accounts/${id}/`,
    authorize: "apple-maps/accounts/authorize/",
    brands: "apple-maps/brands/",
    brandCreationSettings: "apple-maps/brand-creation-settings/"
  },
  freeTool: {
    reports: {
      sentimentProfiles: id => `/reports/${id}/sentiment/profiles`,
      sentimentTrends: id => `/reports/${id}/sentiment/trends`,
      competitorsTracked: id => `/reports/${id}/competitors/tracked`,
      tags: id => `/reports/${id}/tags`,
      verifyEmail: `/reports/verify`,
      statsAvgRating: id => `/reports/${id}/stats/avg-rating`,
      statsResponseRate: id => `/reports/${id}/stats/response-rate`,
      sentimentRadarChartProfilesData: id =>
        `/reports/${id}/sentiment/radar-profiles`,
      info: id => `/reports/${id}/info`
    }
  },
  keywordImpressions: {
    list: "keyword-impressions/",
    summary: "keyword-impressions/summary/",
    topKeywords: "keyword-impressions/top-keywords/",
    keywords: "keyword-impressions/keywords/",
    byDate: "keyword-impressions/by-date/",
    dates: "keyword-impressions/dates/",
    export: "keyword-impressions/export/"
  }
};
